'use client';

/**
 * Keeps site chrome (new-article toast, stale-content refresh, sticky footer
 * ad) off the private /audit/<chain>/… pages: those are shared with one
 * prospect each and carry no site furniture. Children never mount there, so
 * their polling / ad fetches don't run either. The bare /audit/ campaign page
 * is unaffected.
 *
 * The ONLY client component under components/ai-audit (allowlisted in the
 * server-only test). It must import nothing from src/lib/ai-audit: no audit
 * data or config may reach a browser bundle.
 */
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

const PREFIX = '/audit/';

export function isPrivateAuditPath(pathname: string | null): boolean {
  // Anything after `/audit/` counts, including odd forms like `/audit//x`.
  return !!pathname && pathname.startsWith(PREFIX) && pathname.length > PREFIX.length;
}

export default function HideOnPrivateAudit({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (isPrivateAuditPath(pathname)) return null;
  return <>{children}</>;
}
